export const userRoles = {
  SERVICE_PROVIDER_ADMIN : "organization-admin",
  SERVICE_PROVIDER_ADMIN_ROLES : {
    REGULAR_STAFF: "staff",
    MEDICAL_STAFF: "medical_staff",
    DOCTOR : "doctor"
  },
  SUPER_ADMIN : "super-admin",
  SUPER_ADMIN_ROLES: {
    ACCOUNTANT : "accountant",
    CUSTOMER_SUPPORT : "customer-support"
  },
  CUSTOMER : "customer",
  SERVICE_PROVIDERS: 'organisations'
};
